const fakeBackend = () => {
  // This sets the mock adapter on the default instance
};

export default fakeBackend;
